import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { isEmail } from '../../../Forms/fieldValidators'
import { renderSelectField, renderTextAreaField, renderTextField } from '../../../Forms/fieldRenderers'
import { motivosConsulta } from '../../../../config/motivosConsulta'

function ContactoForm () {
  const [motivoConsulta, setMotivoConsulta] = useState(null)

  const renderMotivos = () => {
    const options = motivosConsulta.map((m) => {
      return (
        <option
          value={m}
          key={m}
        >
          {m}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  return (
    <Row>
      <Col md={12}>
        <Field
          name='email'
          type='text'
          label='Su dirección de correo *'
          validate={[isEmail]}
          component={renderTextField}
          autoFocus={false}
        />
      </Col>
      <Col md={6}>
        <Field
          name='asunto'
          type='text'
          label='Asunto'
          component={renderTextField}
        />
      </Col>
      <Col md={6}>
        <Field
          onChange={(m) => setMotivoConsulta(m)}
          name='motivo'
          label='Motivo de consulta *'
          autoFocus={false}
          component={renderSelectField}
          value={motivoConsulta}
          style={{ margin: 0 }}
        >
          {renderMotivos()}
        </Field>
      </Col>
      <Col md={12}>
        <Field
          name='mensaje'
          component={renderTextAreaField}
          autoFocus={false}
          label='Mensaje *'
          style={{
            width: '100%',
            borderColor: '#d2d2d2',
            borderRadius: '4px',
            minHeight: '80px'
          }}
        />
      </Col>
      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>
    </Row>
  )
}

export default ContactoForm
